<div class="dialog-container">
    <div class="title">
      <h4 mat-dialog-title>Download</h4>
    </div>
    <hr>
      <div class="dialog-contents" mat-dialog-content>       
        <div class="formElementsRow ">
            <label>Choose format for download</label>
            <br /><br />
            <mat-radio-group aria-label="Select an option"  [(ngModel)]="downloadDataType" >
              <mat-radio-button color="primary" value="csv">CSV</mat-radio-button>
              <mat-radio-button color="primary" value="excel">Excel</mat-radio-button>
            </mat-radio-group>
        </div>
      </div>
      
      <div mat-dialog-actions align="end">
        <button mat-button class="mat-button-sm cancel_btn" mat-dialog-close>CANCEL</button>
        <button  mat-flat-button (click)="download()"
          class="mat-button-primary-sm">Confirm & Download</button>
      </div>
  </div>